import API, { API_URL } from "api/API";
import { ApiResult } from "libs/types";

interface GetForecastDevDelayApiResult extends ApiResult {
  forecast: number;
  sat_image: number;
}

async function getForecastDevDelayApi():Promise<GetForecastDevDelayApiResult> {
  const {data} = await API.get(`${API_URL.FORECAST.GET_DEV_DELAY}`);

  return data;
}

export default getForecastDevDelayApi;